import React, { useState } from "react"
import { observer } from "mobx-react"
import { Col, Flex, Form, Input, Row, Typography } from "antd"
import { PlusCircleOutlined } from "@ant-design/icons"

import { GlobalTokensCollection } from "@src/pages/settingsApiKeys/classes/TokensCollection"
import ScopesSelect from "@src/pages/settingsApiKeys/ui/ScopesSelect"
import { TokensTable } from "@src/pages/settingsApiKeys/ui/TokensTable"
import { SubmitButton } from "@src/shared/componemts/SubmitButton"

export const SettingsApiKeysPage = observer(() => {
  const tokens = GlobalTokensCollection()
  const [form] = Form.useForm()
  const [isOpen, setIsOpen] = useState(false)

  const reset = () => {
    form.resetFields()
    setIsOpen(false)
  }

  return (
    <Flex gap={32} style={{ width: "100%" }} vertical>
      <Typography.Text style={{ fontSize: 16, width: "90%" }}>
        In order to access most API endpoints, please create an API key. Once
        you have generated your API key, be sure to either copy it or click on
        the eye icon to reveal the entire API key.
      </Typography.Text>

      <Form
        form={form}
        id="GENERATED_ID_SETTINGSAPIKEYS_FORM_VOID_1"
        layout="vertical"
        style={{ width: "100%" }}
      >
        <Row align="top" gutter={32}>
          <Col span={16}>
            <Flex vertical>
              <Form.Item
                id="GENERATED_ID_SETTINGSAPIKEYS_FORM_ITEM_VOID_1"
                label="Key name"
                name="name"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter name" />
              </Form.Item>
              <ScopesSelect
                isLoading={tokens.scopes.isLoading}
                isOpen={isOpen}
                scopesGroups={tokens.scopes.groups}
                updateOpen={setIsOpen}
              />
            </Flex>
          </Col>

          <Col span={4}>
            <Form.Item label={" "}>
              <SubmitButton
                buttonProps={{
                  disabled: tokens.isLoadStatus,
                  icon: <PlusCircleOutlined />,
                  loading: tokens.isLoadStatus,
                  onClick: () =>
                    tokens.create(form.getFieldsValue()).then((_) => reset()),
                  type: "primary",
                }}
                form={form}
              >
                Create New Key
              </SubmitButton>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      {(!tokens.isEmpty || tokens.isLoading) && (
        <TokensTable collection={tokens} />
      )}
    </Flex>
  )
})
